import { Suspense, useContext, useEffect, useState } from "react";
import { Avatar, Grid } from "@material-ui/core";
import { GroupDetails } from "../../../../../../@types/components/assignGroupsProps.types";
import { GroupContext } from "../../../../../../contexts";
import { BBILogo } from "../../../../../../assets";
import { AnnouncementGroupProfile } from "../../../..";

import GroupWorkIcon from "@material-ui/icons/GroupWork";
import GroupIcon from "@material-ui/icons/Group";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";

import "./groupInformation.css";

const GroupInformation = () => {
	const [groupBasicDetails, setGroupBasicDetails] = useState<GroupDetails>();
	const [coverageDetails, setCoverageDetails] = useState<GroupDetails>();
	const [locationBasicDetails, setLocationBasicDetails] = useState<GroupDetails>();
	const { groupInformation, locationInformation } = useContext(GroupContext);

	useEffect(() => {
		if (groupInformation || locationInformation) {
			if (groupInformation) {
				setGroupBasicDetails(
					Object.assign(
						{},
						{
							"Physical Name": groupInformation?.group_info?.physical_name,
							"Tax ID": groupInformation?.group_info?.TAX_ID,
							"Address Line 1": groupInformation?.group_info?.address_1,
							"Address Line 2": groupInformation?.group_info?.address_2,
							City: groupInformation?.group_info?.city,
							State: groupInformation?.group_info?.state,
							Zip: groupInformation?.group_info?.ZIP,
							Fax: groupInformation?.group_info?.fax
						}
					)
				);
				setCoverageDetails(
					Object.assign(
						{},
						{
							"Medical Coverage": groupInformation?.group_info?.medical_coverage === "T" ? "True" : "N/A",
							"Vision Coverage": groupInformation?.group_info?.vision_coverage === "T" ? "True" : "N/A",
							"Dental Coverage": groupInformation?.group_info?.dental_coverage === "T" ? "True" : "N/A",
							"Drug Coverage": groupInformation?.group_info?.drug_coverage === "T" ? "True" : "N/A",
							"Miscellenous Coverage":
								groupInformation?.group_info?.miscellaneous_coverage === "T" ? "True" : "N/A",
							"LTD Coverage": groupInformation?.group_info?.LTD_coverage === "T" ? "True" : "N/A",
							"STD Coverage": groupInformation?.group_info?.STD_coverage === "T" ? "True" : "N/A",
							"Life Coverage": groupInformation?.group_info?.life_coverage === "T" ? "True" : "N/A"
						}
					)
				);
			} else if (locationInformation) {
				setLocationBasicDetails(
					Object.assign(
						{},
						{
							"Physical Name": "Brookshire Brothers, Inc",
							"Tax ID": "T124XP749",
							"Address Line 1": "5 Blocks from Street 2A",
							"Address Line 2": "2 Blocks from Street 2A",
							City: "Houston",
							State: "Texas",
							Zip: "700129",
							Fax: "F12P422"
						}
					)
				);
			}
		}
	}, [groupInformation, locationInformation]);
	// console.log("groupInformation", groupInformation);
	return (
		<div className="group-information">
			{groupInformation && groupInformation.group_info.logo ? (
				<div className="logo">
					<img src={BBILogo} alt="logo" />
				</div>
			) : (
				<Avatar className="logo-avatar">
					{groupInformation && groupInformation.group_info && groupInformation.group_info.name[0]}
				</Avatar>
			)}
			<div className="group-name">
				{groupInformation && groupInformation.group_info && groupInformation.group_info.name}
			</div>
			<div className="divider-container">
				<div className="dark-divider" />
				<div className="green-divider" />
			</div>
			<Grid container className="details" spacing={2}>
				{groupInformation && groupBasicDetails && coverageDetails ? (
					<>
						<Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
							<Suspense fallback={<div />}>
								<AnnouncementGroupProfile details={groupBasicDetails} header={"Basic Details"} />
							</Suspense>
						</Grid>
						<Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
							<Suspense fallback={<div />}>
								<AnnouncementGroupProfile details={coverageDetails} header={"Coverage"} />
							</Suspense>
						</Grid>
					</>
				) : (
					<Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
						{locationBasicDetails ? (
							<Suspense fallback={<div />}>
								<AnnouncementGroupProfile details={locationBasicDetails} header={"Basic Details"} />
							</Suspense>
						) : null}
					</Grid>
				)}
			</Grid>
			<div className="special-details">
				<div className="special-detail">
					<GroupWorkIcon />
					<div className="field">
						<span className="label">Master Number:</span>
						<span className="value">&nbsp; 202-210</span>
					</div>
				</div>
				<div className="special-detail">
					<GroupIcon />
					<div className="field">
						<span className="label">Group Number:</span>
						<span className="value">&nbsp; &nbsp;220</span>
					</div>
				</div>
				<div className="special-detail">
					<EmailIcon />
					<div className="field">
						<span className="label">Email:</span>
						<span className="value">&nbsp; contact@bbi.com</span>
					</div>
				</div>
				<div className="special-detail">
					<PhoneIcon />
					<div className="field">
						<span className="label">Phone:</span>
						<span className="value">&nbsp; +148-441-45965</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GroupInformation;
